import { TextField, useFormContext } from '@calendly/form'
import { I18n } from '@calendly/i18n'
import { LockIcon } from '@calendly/ui/components/icons'
import { BodyText } from '@calendly/ui/components/typography'

import { useEnforceUpgrade } from 'components/billing/useEnforceUpgrade'
import { VerticalSortableContext } from 'components/core/sortable'

import { AddButton } from '../../../components'
import { StatusField } from '../status_field'
import { HeaderWithIcon, PanelContentContainer, PanelContentHeader, PanelContentTitle } from '../styles'
import { CustomLink } from './custom_link'
import { generateBlankCustomLink, reorderLinks } from './helpers'

export const InternalSection = () => {
  const { values: { customLinks }, setFieldValue } = useFormContext()
  const enforceUpgrade = useEnforceUpgrade('custom_links')
  const undeletedLinks = customLinks.filter(({ _destroy }) => !_destroy)

  const setItems = (items) => {
    setFieldValue('customLinks', reorderLinks(customLinks, items))
  }

  const onAdd = (newCustomLink) => {
    setFieldValue('customLinks', [...customLinks, newCustomLink])
  }

  const handleAdd = () => {
    enforceUpgrade(() => {
      onAdd(generateBlankCustomLink(undeletedLinks.length))
    })
  }

  return (
    <PanelContentContainer section>
      <PanelContentHeader>
        <PanelContentTitle>
          {I18n.t('publisher.event_type_editor.sections.booking_page_options.confirmation_page.links_on_confirmation_page')}
        </PanelContentTitle>
      </PanelContentHeader>
      <PanelContentContainer subsection>
        <HeaderWithIcon>
          <LockIcon />
          <BodyText size="medium" weight="bold">
            {I18n.t('publisher.event_type_editor.sections.booking_page_options.confirmation_page.custom_link.link_name')}
          </BodyText>
        </HeaderWithIcon>
        <TextField
          name="anotherEventButtonLabel"
          aria-label={I18n.t('publisher.event_type_editor.sections.booking_page_options.confirmation_page.custom_link.link_name')}
        />
        <StatusField name="anotherEventButtonEnabled" />
      </PanelContentContainer>
      <VerticalSortableContext items={undeletedLinks} setItems={setItems}>
        {customLinks.map((link, index) => (
          <CustomLink index={index} key={link.id} link={link} />
        ))}
      </VerticalSortableContext>
      <AddButton onClick={handleAdd}>
        {I18n.t('publisher.event_type_editor.sections.more_options.confirmation_page.add_new_link')}
      </AddButton>
    </PanelContentContainer>
  )
}
